import React, { useMemo } from "react";
import { Sponsor } from "../../app/types";

interface Props {
  sponsor: Sponsor;
}

const SponsorCard = ({ sponsor }: Props) => {
  const { name, imageUrl, level, description, url } = sponsor;

  const tier = useMemo(() => Math.min(level, 2), [level]);

  return (
    <>
      <div className={`tier-${tier} tier`}>
        <img
          className={`banner-${tier} banner`}
          src={imageUrl}
          alt={`${name} logo`}
        />
        <h4 className="name">{name}</h4>
        {level > 1 && <h4 className="description">{description}</h4>}
        {level > 0 && (
          <h3>
            <a href={url} className="link">
              {url}
            </a>
          </h3>
        )}
      </div>
      <style jsx>
        {`
          .tier {
            margin: 0 30px 0 0;
          }
          .tier-2 {
            width: 320px;
          }
          .tier-1 {
            width: 180px;
          }
          .tier-0 {
            width: 130px;
          }
          .banner {
            width: 100%;
            object-fit: contain;
          }
          .banner-2 {
            height: 110px;
          }
          .banner-1 {
            height: 100px;
          }
          .banner-0 {
            height: 50px;
          }
          .description {
            font-weight: normal;
            font-size: 0.8rem;
          }
          .link {
            font-size: 0.8rem;
            color: blue;
          }
        `}
      </style>
    </>
  );
};
export default SponsorCard;
